import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getAccountReceivableClientAggregatesQueryOptions } from '@/_pages/account-receivables/api-service';
import {
  buildAccountReceivablesApiParamStr,
  mergeAccountReceivablesListQueryParams,
} from '@/_pages/account-receivables/shared';

function withCompanySort(apiParamStr: string) {
  const [prefix, query = ''] = apiParamStr.split('?');
  const params = query.split('&').filter((part) => part.length > 0 && !part.startsWith('sort='));
  return `${prefix}?${params.join('&')}`;
}

export const Route = createFileRoute('/_private/account-receivables/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => {
    const search = filterState.parse(opts.location.search ?? {});
    const apiParamStr = buildAccountReceivablesApiParamStr(search);
    const listQuery = mergeAccountReceivablesListQueryParams(apiParamStr, {
      includeAllReceivables: false,
      advanceFilterClauses: [],
      forByClientsApi: true,
    });
    return opts.context.queryClient.ensureQueryData(
      getAccountReceivableClientAggregatesQueryOptions(withCompanySort(listQuery))
    );
  },
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} numberOfButtons={0} />,
});
